module.exports = __webpack_public_path__ + "img/closed-loop-4.e331e710.png";